export default __webpack_public_path__ + "locales/lv/CreateEditRoomDialog.json?hash=315f50f94f2c77d4f5dee2f5c68e3d92";